import React from 'react';
import { render } from 'react-dom';
import browserCheck from '@ublend-npm/browser-check';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { fetchInstitution } from '@core/actions/institutions';
import { initializeViewportHeightVar } from './utils/viewportHeight';
import App from './app';
import { configureStore } from './store';
import ErrorPage from './components/error';

// to be added for error logging
// import ErrorBoundary from '@core/error/ErrorBoundary';
// import {
//   registerGlobalErrorListeners,
//   reportError,
// } from '@core/error/globalErrorListeners';
// import { setupOfflineSync } from '@core/error/syncOfflineErrors';

if (module.hot) {
  module.hot.accept();
}

const defaultAnonymousUserKey = '4382d193-adc7-41ab-9af7-1000a4715915';

const getInstitution = () => {
  const host = window.location.hostname.split('.');

  return process.env.INSTITUTION || (host[0] === 'beta' ? host[1] : host[0]);
};

const getInstitutionData = async (store) => {
  await store.dispatch(fetchInstitution(getInstitution()));

  return store.getState().institution;
};

// to be added for error logging
// registerGlobalErrorListeners();
// setupOfflineSync();

(async () => {
  initializeViewportHeightVar();

  if (browserCheck.isAllowedBrowser() || window.location.host.includes('pa-')) {
    const store = configureStore();
    let institutionData;
    try {
      institutionData = await getInstitutionData(store);
    } catch (error) {
      return render(
        <ErrorPage error={error} />,
        document.getElementById('app')
      );
    }

    const {
      keys: { launchDarkly },
      general: { institution },
    } = institutionData;
    const LDProvider = await asyncWithLDProvider({
      clientSideID: launchDarkly?.clientSideId,
      context: {
        kind: 'user',
        key: defaultAnonymousUserKey,
        institution,
      },
    });

    if (process.env.NODE_ENV === 'local') {
      // eslint-disable-next-line global-require
      const { worker } = require('../test/mocks/browser');
      worker.start({
        onUnhandledRequest: 'bypass',
      });
    }

    render(
      <LDProvider>
        {/*
        to be added for error logging
        <ErrorBoundary
          onError={(err, info) => {
            reportError({
              type: 'react-boundary',
              message: err?.message,
              stack: err?.stack,
              info,
            });
          }}
        >
          <App store={store} institutionData={institutionData} />
        </ErrorBoundary> */}
        <App store={store} institutionData={institutionData} />
      </LDProvider>,
      document.getElementById('app')
    );
  } else {
    render(browserCheck.AutoWarning(), document.getElementById('app'));
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js') // this file should be generated in 'dist' folder after build
        .then((reg) => console.log('SW registered: ', reg))
        .catch((err) => console.error('SW registration failed: ', err));
    });
  }
})();
